import styled from "styled-components";

export const Button = styled.button`

    -webkit-apparence:none;
`;
